"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const import_1 = require("./util/import");
const platform_1 = require("./util/platform");
const ERROR_LOG_FILE = 'akord-error.log';
class Logger {
}
exports.Logger = Logger;
Logger.debug = false;
Logger.logToFile = false;
Logger.error = function (error) {
    if (this.debug) {
        console.error(error);
    }
    if (this.logToFile && (0, platform_1.isServer)()) {
        const fs = (0, import_1.importDynamic)("fs");
        const logMessage = `${new Date().toISOString()} - ERROR - ${formatErrorLog(error)}\n`;
        fs.appendFileSync(ERROR_LOG_FILE, logMessage);
    }
};
Logger.log = function (message) {
    if (this.debug) {
        console.log(message);
    }
};
Logger.warn = function (message) {
    if (this.debug) {
        console.warn(message);
    }
};
const formatErrorLog = (error) => {
    const replacer = (key, value) => key === '_sessionCache' ? undefined : value;
    const stringifiedError = JSON.stringify(error || {}, replacer, 2);
    return stringifiedError.length === 0
        ? stringifiedError
        : error;
};
